module.exports = __webpack_public_path__ + "static/media/arrow-right.0be4acb1.svg";